import { render } from "./InfoItem.vue?vue&type=template&id=7f389803&ts=true"
import script from "./InfoItem.vue?vue&type=script&lang=ts"
export * from "./InfoItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__